import { AppTable } from 'shared/UI/UIKit/Table';
import type { Room } from 'services/api';
import type { PropsWithClassName } from 'shared/types';
import type { AppTableColumn, AppTableOnChange, AppTableState } from 'shared/UI/UIKit/Table';

interface RoomTableProps extends PropsWithClassName {
  dataSource: Room[];
  loading: boolean;
  columns: AppTableColumn<Room>[];
  onChange: AppTableOnChange;
  tableState: AppTableState;
}

export const RoomsTable = ({
  dataSource,
  columns,
  onChange,
  loading,
  className,
  tableState,
}: RoomTableProps) => {
  return (
    <AppTable
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
      loading={loading}
      rowKey={(record) => record.id!}
      className={className}
      pagination={tableState.pagination}
      sorters={tableState.sorters}
    />
  );
};
